module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.lAction === 'view') ? _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 mt-1",
    attrs: {
      "append-icon": "search",
      "placeholder": _vm.$vuetify.breakpoint.smAndUp ? 'Search by Incident class, Description, etc.' : 'Search',
      "single-line": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.incidentHeaderSm,
      "items": _vm.incidentList,
      "title": "Incidents List",
      "landscape": true
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-3 mt-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.incidentHeaderSm : _vm.incidentHeader,
      "items": _vm.incidentList,
      "hide-actions": "",
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareUpdate(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.incident_on)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_type))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.incident_class))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.incident_desc))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.created_by_name))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.created_on)))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.incident_status))]) : _vm._e()])]
      }
    }], null, false, 3924591836)
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showPastIncidents($event)
      }
    }
  }, [_vm._v("View Past Incidents")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    staticClass: "pa-0",
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lIncident.incident_type),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incident_type", $$v)
      },
      expression: "lIncident.incident_type"
    }
  }, _vm._l((_vm.incidentTypes), function(type, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "xs6": ""
      }
    }, [_c('v-radio', {
      attrs: {
        "label": type,
        "value": type
      }
    })], 1)
  }), 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Incident class",
      "items": _vm.incidentClass.filter(function (rec) { return rec.incident_type === _vm.lIncident.incident_type; }),
      "item-text": "incident_class",
      "item-value": "incident_class_id",
      "rules": [_vm.rules.required]
    },
    model: {
      value: (_vm.lIncident.incident_class_id),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incident_class_id", $$v)
      },
      expression: "lIncident.incident_class_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    ref: "incidentOnDate",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lIncident.incidentDt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "incidentDt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "incidentDt", $event)
      }
    },
    model: {
      value: (_vm.incidentOnDate),
      callback: function($$v) {
        _vm.incidentOnDate = $$v
      },
      expression: "incidentOnDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.lIncident.incident_type.includes('Outage') ? 'Outage start dt' : 'Incident date',
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.incidentDt),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentDt", $$v)
      },
      expression: "lIncident.incidentDt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "max": _vm.today
    },
    model: {
      value: (_vm.lIncident.incidentDt),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentDt", $$v)
      },
      expression: "lIncident.incidentDt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.incidentOnDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.incidentOnDate.save(_vm.lIncident.incidentDt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    ref: "incidentTime",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "lazy": "",
      "return-value": _vm.lIncident.incidentTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "incidentTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "incidentTime", $event)
      }
    },
    model: {
      value: (_vm.incidentTime),
      callback: function($$v) {
        _vm.incidentTime = $$v
      },
      expression: "incidentTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.lIncident.incident_type.includes('Outage') ? 'Time' : 'Incident time',
      "append-icon": "access_time",
      "clearable": "",
      "hide-details": "",
      "readonly": "",
      "rules": [_vm.rules.required]
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.incidentTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentTime", $$v)
      },
      expression: "lIncident.incidentTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lIncident.incidentTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentTime", $$v)
      },
      expression: "lIncident.incidentTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.incidentTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.incidentTime.save(_vm.lIncident.incidentTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), (_vm.lIncident.incident_type.includes('Outage')) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    ref: "incidentEndDate",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lIncident.incidentDt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "incidentDt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "incidentDt", $event)
      }
    },
    model: {
      value: (_vm.incidentEndDate),
      callback: function($$v) {
        _vm.incidentEndDate = $$v
      },
      expression: "incidentEndDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Outage end dt",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.incidentEndDate),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentEndDate", $$v)
      },
      expression: "lIncident.incidentEndDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "max": _vm.today
    },
    model: {
      value: (_vm.lIncident.incidentEndDate),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentEndDate", $$v)
      },
      expression: "lIncident.incidentEndDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.incidentEndDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.incidentEndDate.save(_vm.lIncident.incidentEndDate)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lIncident.incident_type.includes('Outage')) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    ref: "incidentEndTime",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "lazy": "",
      "return-value": _vm.lIncident.incidentEndTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "incidentEndTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "incidentEndTime", $event)
      }
    },
    model: {
      value: (_vm.incidentEndTime),
      callback: function($$v) {
        _vm.incidentEndTime = $$v
      },
      expression: "incidentEndTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Time",
      "append-icon": "access_time",
      "clearable": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.incidentEndTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentEndTime", $$v)
      },
      expression: "lIncident.incidentEndTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lIncident.incidentEndTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incidentEndTime", $$v)
      },
      expression: "lIncident.incidentEndTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.incidentEndTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.incidentEndTime.save(_vm.lIncident.incidentEndTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1) : _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }), _vm._v(" "), (_vm.lIncident.incident_type === 'Accident') ? _c('v-flex', {
    staticClass: "pb-3",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "hide-details": "",
      "row": ""
    },
    model: {
      value: (_vm.lIncident.is_perm_staff),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "is_perm_staff", $$v)
      },
      expression: "lIncident.is_perm_staff"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Permanent Staff",
      "value": "true"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Temporary Staff",
      "value": "false"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.lIncident.incident_type === 'Accident' && _vm.lIncident.is_perm_staff === 'true') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Staff name",
      "items": _vm.staffList,
      "item-text": "staff_name",
      "item-value": "staff_id",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lIncident.staff_id),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "staff_id", $$v)
      },
      expression: "lIncident.staff_id"
    }
  })], 1) : (_vm.lIncident.incident_type === 'Accident') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Staff name",
      "hide-details": "",
      "rules": [_vm.rules.required],
      "maxlength": "50"
    },
    model: {
      value: (_vm.lIncident.temp_staff_name),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "temp_staff_name", $$v)
      },
      expression: "lIncident.temp_staff_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "mt-2",
    attrs: {
      "label": "Incident description",
      "rules": [_vm.rules.required],
      "rows": "3",
      "outline": "",
      "maxlength": "2000",
      "hide-details": ""
    },
    model: {
      value: (_vm.lIncident.incident_desc),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incident_desc", $$v)
      },
      expression: "lIncident.incident_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Severity",
      "items": ['Low', 'Medium', 'High'],
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lIncident.severity),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "severity", $$v)
      },
      expression: "lIncident.severity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": ['Open', 'Closed']
    },
    model: {
      value: (_vm.lIncident.incident_status),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "incident_status", $$v)
      },
      expression: "lIncident.incident_status"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "primary--text subheading"
  }, [_c('strong', [_vm._v("Reporting Of Incident")])]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('i', [_vm._v(" (Major incidents/outages have to be reported to concern person based on SOP, optional otherwise)")])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    ref: "reportOnDate",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lIncident.reportDt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "reportDt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "reportDt", $event)
      }
    },
    model: {
      value: (_vm.reportOnDate),
      callback: function($$v) {
        _vm.reportOnDate = $$v
      },
      expression: "reportOnDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Reported date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.reportDt),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "reportDt", $$v)
      },
      expression: "lIncident.reportDt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "max": _vm.today
    },
    model: {
      value: (_vm.lIncident.reportDt),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "reportDt", $$v)
      },
      expression: "lIncident.reportDt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.reportOnDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.reportOnDate.save(_vm.lIncident.reportDt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm3": ""
    }
  }, [_c('v-dialog', {
    ref: "reportedTime",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "lazy": "",
      "return-value": _vm.lIncident.reportTime
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "reportTime", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "reportTime", $event)
      }
    },
    model: {
      value: (_vm.reportedTime),
      callback: function($$v) {
        _vm.reportedTime = $$v
      },
      expression: "reportedTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Reported time",
      "append-icon": "access_time",
      "clearable": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.reportTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "reportTime", $$v)
      },
      expression: "lIncident.reportTime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lIncident.reportTime),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "reportTime", $$v)
      },
      expression: "lIncident.reportTime"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.reportedTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.reportedTime.save(_vm.lIncident.reportTime)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Reported to",
      "hide-details": "",
      "maxlength": "30"
    },
    model: {
      value: (_vm.lIncident.reported_to),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "reported_to", $$v)
      },
      expression: "lIncident.reported_to"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "primary--text subheading"
  }, [_c('strong', [_vm._v("Root Cause and Preventive Measure")])]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('i', [_vm._v(" (Filled-in after investigation; optional if no investigation required)")])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-dialog', {
    ref: "investigatedDate",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lIncident.investigated_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lIncident, "investigated_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lIncident, "investigated_dt", $event)
      }
    },
    model: {
      value: (_vm.investigatedDate),
      callback: function($$v) {
        _vm.investigatedDate = $$v
      },
      expression: "investigatedDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Investigated date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lIncident.investigated_dt),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "investigated_dt", $$v)
      },
      expression: "lIncident.investigated_dt "
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "min": _vm.lIncident.incidentDt,
      "max": _vm.today
    },
    model: {
      value: (_vm.lIncident.investigated_dt),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "investigated_dt", $$v)
      },
      expression: "lIncident.investigated_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.investigatedDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.investigatedDate.save(_vm.lIncident.investigated_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Investigated by",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lIncident.investigated_by),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "investigated_by", $$v)
      },
      expression: "lIncident.investigated_by "
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "mt-2",
    attrs: {
      "label": "RCA",
      "hide-details": "",
      "rows": "3",
      "outline": "",
      "maxlength": "2000"
    },
    model: {
      value: (_vm.lIncident.rca),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "rca", $$v)
      },
      expression: "lIncident.rca"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "mt-2",
    attrs: {
      "label": "Corrective action",
      "rows": "3",
      "outline": "",
      "hide-details": "",
      "maxlength": "2000"
    },
    model: {
      value: (_vm.lIncident.corrective_action),
      callback: function($$v) {
        _vm.$set(_vm.lIncident, "corrective_action", $$v)
      },
      expression: "lIncident.corrective_action"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser()
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lIncident.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lIncident.files), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v("\n                              " + _vm._s(file.file_name) + "\n                              "), (!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": _vm.config.FM_SPACES_BASE_URL + file.file_url,
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "mr-0 grey lighten-1 grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e()])], 1)
  }), 0) : _c('span', [_vm._v("Attachment if any"), _c('br'), _c('span', {
    staticClass: "caption"
  }, [_vm._v("(supports images, pdfs, docs and excels upto 20MB)")])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.lAction = 'view'
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), (_vm.lAction === 'update') ? _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.deleteIncident($event)
      }
    }
  }, [_vm._v("Delete")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.prepareViewForPdf()
      }
    }
  }, [_vm._v("View")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: (_vm.showPastInc),
      callback: function($$v) {
        _vm.showPastInc = $$v
      },
      expression: "showPastInc"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_c('span', [_vm._v("Closed incidents (" + _vm._s(_vm.pastIncidents.length) + ")")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showPastInc = false;
        _vm.searchPast = ''
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    staticClass: "elevation-3 mt-3",
    attrs: {
      "headers": _vm.$vuetify.breakpoint.smAndUp ? _vm.incidentHeaderSm : _vm.incidentHeader,
      "items": _vm.pastIncidents,
      "hide-actions": "",
      "search": _vm.searchPast
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.prepareUpdate(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.incident_on)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.incident_type))]), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.incident_class))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.incident_desc))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.created_by_name))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.created_on)))]) : _vm._e(), _vm._v(" "), (_vm.$vuetify.breakpoint.smAndUp) ? _c('td', [_vm._v(_vm._s(props.item.incident_status))]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.searchPast),
      callback: function($$v) {
        _vm.searchPast = $$v
      },
      expression: "searchPast"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "headers": _vm.incidentHeaderSm,
      "items": _vm.pastIncidents,
      "title": "Closed incidents"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: (_vm.showPastIncView),
      callback: function($$v) {
        _vm.showPastIncView = $$v
      },
      expression: "showPastIncView"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-0 grey lighten-3",
    staticStyle: {
      "font-size": "17px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n            Incident View\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.downloadAsPdf()
      }
    }
  }, [_vm._v("Save as Pdf")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.showPastIncView = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    attrs: {
      "id": "form"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm11": "",
      "mx-auto": "",
      "id": "pdf_report"
    }
  }, [_c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "height": "30",
      "src": require("../../static/img/logo/smartility_admin.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "accent--text font-weight-bold",
    staticStyle: {
      "text-align": "center",
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.comm_det[0] ? _vm.comm_det[0].comm_name : '-'))]), _vm._v(" "), _c('div', {
    staticClass: "pt-1 font-weight-bold",
    staticStyle: {
      "text-align": "center",
      "font-size": "16px"
    }
  }, [_vm._v("Incident Report")]), _vm._v(" "), _c('div', {
    staticClass: "pt-3"
  }, [_c('hr')])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "subheading font-weight-bold"
  }, [_vm._v("Incident Details")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Incident Type")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incident_type ? _vm.lIncident.incident_type : ''))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Incident Class")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.incidentClass.filter(function (rec) { return rec.incident_type === _vm.lIncident.incident_type && rec.incident_class_id === _vm.lIncident.incident_class_id; })[0] ? _vm.incidentClass.filter(function (rec) { return rec.incident_type === _vm.lIncident.incident_type && rec.incident_class_id === _vm.lIncident.incident_class_id; })[0].incident_class : ''))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Severity")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.severity ? _vm.lIncident.severity : '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incident_status ? _vm.lIncident.incident_status : '-'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incident_type ? _vm.lIncident.incident_type.includes('Outage') ? 'Outage Start Date' : 'Incident Date' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incidentDt ? _vm.lIncident.incidentDt : '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incident_type ? _vm.lIncident.incident_type.includes('Outage') ? 'Outage Time' : 'Incident Time' : ''))]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incidentTime ? _vm.lIncident.incidentTime : '-'))])]), _vm._v(" "), (_vm.lIncident.incident_type ? _vm.lIncident.incident_type.includes('Outage') ? true : false : false) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Outage End Date")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incidentEndDate ? _vm.lIncident.incidentEndDate : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.lIncident.incident_type ? _vm.lIncident.incident_type.includes('Outage') ? true : false : false) ? _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Outage End Time")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incidentEndTime ? _vm.lIncident.incidentEndTime : '-'))])]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.lIncident.incident_type === 'Accident') ? _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Staff Type")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.is_perm_staff ? 'Permanent Staff' : 'Temporary Staff'))])])], 1) : _vm._e(), _vm._v(" "), (_vm.lIncident.incident_type === 'Accident' && _vm.lIncident.is_perm_staff === 'true') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Staff Name")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.staffList.filter(function (rec) { return rec.staff_id === _vm.lIncident.staff_id; })[0] ? _vm.staffList.filter(function (rec) { return rec.staff_id === _vm.lIncident.staff_id; })[0].staff_name : ''))])])], 1) : (_vm.lIncident.incident_type === 'Accident') ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Temp Staff Name")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.temp_staff_name ? _vm.lIncident.temp_staff_name : ''))])])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Incident Description")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.incident_desc ? _vm.lIncident.incident_desc : '-'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "subheading font-weight-bold"
  }, [_c('strong', [_vm._v("Reporting Of Incident")])]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('i', [_vm._v(" (Major incidents/outages have to be reported to concern person based on SOP, optional otherwise)")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Reported Date")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.reportDt ? _vm.lIncident.reportDt : '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Reported Time")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.reportTime ? _vm.lIncident.reportTime : '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Reported To")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.reported_to ? _vm.lIncident.reported_to : '-'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "subheading font-weight-bold"
  }, [_c('strong', [_vm._v("Root Cause and Preventive Measure")])]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('i', [_vm._v(" (Filled-in after investigation; optional if no investigation required)")])])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Investigated Date")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.investigated_dt ? _vm.lIncident.investigated_dt : '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "caption font-weight-bold"
  }, [_vm._v("Investigated By")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.investigated_by ? _vm.lIncident.investigated_by : '-'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "subheading font-weight-bold"
  }, [_vm._v("Root Cause Analysis (RCA)")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.rca ? _vm.lIncident.rca : '-'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "subheading font-weight-bold"
  }, [_vm._v("Corrective Action")]), _vm._v(" "), _c('div', {
    staticClass: "blue--text font-weight-bold"
  }, [_vm._v(_vm._s(_vm.lIncident.corrective_action ? _vm.lIncident.corrective_action : '-'))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pt-3"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "pt-1",
    staticStyle: {
      "text-align": "center",
      "font-size": "12px"
    }
  }, [_vm._v("--- end of incident report ---")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:20px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-fad844f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Incidents.vue
// module id = 868
// module chunks = 5